var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot-info-page foot_info"},[_c('van-image',{attrs:{"src":require('@/assets/logo.png'),"width":"140","height":"24"}}),_c('span',{staticClass:"compy_info info_default font_10"},[_vm._v(_vm._s(_vm.$t('publice.footer')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }